import React, { useState } from "react";

export interface INavInkImageProps {
  src: string;
  altSrc?: string;
}

export const NavInkImage = (props: INavInkImageProps) => {
  const [useAltSrc, setUseAltSrc] = useState<boolean>(false);

  return (
    <img
      src={useAltSrc ? props.altSrc : props.src}
      alt="Item"
      onError={
        useAltSrc
          ? undefined
          : () => {
              setUseAltSrc(true);
            }
      }
    />
  );
};
